export default "__VITE_ASSET__Dn7HgGjb__"